module.exports = __webpack_public_path__ + "tables/media/Tables_outlined.7ea18898.svg";